import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A history of my worst technical achievements",
  "description": "",
  "published": "2012-07-09T00:00:00.000Z",
  "redirect_from": ["/blog/a-history-of-my-worst-technical-achievements/swizec/4811"],
  "categories": "Games, GOTO, Graphical user interface, Pascal, Source lines of code, Space Invader, Space Invaders, Turbo Pascal, Uncategorized, Video game",
  "hero": "./img/Swizec-Twitulater-blob-master-webby-gallery-1.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday `}<a parentName="p" {...{
        "href": "http://news.ycombinator.com/item?id=4213564"
      }}>{`a comment on HackerNews`}</a>{` got me thinking about the horrible `}<em parentName="p">{`horrible`}</em>{` code I used to produce as a young human (and to this day)`}</p>
    <blockquote>
      <p parentName="blockquote">{`To be honest, I wouldn't worry too much. Everyone is like "I was programming since I was 10!" Nobody ever asks what they were programming at 10, most people wrote relatively simple stuff until they grew up and got a professional job.`}</p>
      <p parentName="blockquote">{`Now to wait for replies from people who designed OSes when they were 12 :)`}</p>
    </blockquote>
    <p>{`I started programming when I was 9 because there was a class at my school. Without that class I'd probably become something silly like a writer or a linguist. Thank you `}<a parentName="p" {...{
        "href": "http://www.zri.si/"
      }}>{`ZRI`}</a>{` and the awesome professor whose name I can never remember. You guys are great!`}</p>
    <p>{`Back then I used Logo, which was fun, but the `}<em parentName="p">{`real`}</em>{` fun started when they let me loose on Pascal at 11. I have no idea how good a coder I was for an 11 year old, all I know is that I was a `}<em parentName="p">{`terrible`}</em>{` coder by real standards.`}</p>
    <p>{`Here is a non-exhaustive list of the worst monstrosities I have created in the past 13 years.`}</p>
    <h2 {...{
      "id": "1-a-maths-tutoring-program"
    }}>{`1. A maths tutoring program`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 11`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: Pascal and text "graphics"`}</p>
    <p>{`I wanted to make maths exercises and present them to the user. Use random to produce infinite examples.`}</p>
    <p>{`But, I didn't know about `}<em parentName="p">{`GotoXY`}</em>{` yet and couldn't print things at specific points on a text screen. That's why I implemented the welcome screen as a set of procedures that would print an increasing number of empty lines before the `}<em parentName="p">{`"WELCOME!"`}</em>{` line.`}</p>
    <p>{`I needed many procedures because I didn't know about loops either - each had a hardcoded number of empty lines. They were called as a huge chunk of code with a `}{`_`}{`delay `}{`_`}{`to make it smooth.`}</p>
    <p>{`Code lost to history.`}</p>
    <h2 {...{
      "id": "2-a-space-invaders-game"
    }}>{`2. A space invaders game`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 11`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: Pascal and BGI graphics`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "207px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/60a2182c850f400047cfb954ef3f270d/661c4/English-One-of-several-aliens-found-in-the-se611124.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.8792270531401%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M83%2017L68%2033v33h35v3c0%203%200%203-2%203a692%20692%200%2000-66%2064c-2%200-7%205-18%2015L2%20166v49l1%2050h31l15-15%2015-14v-19c0-18%200-19%202-19s2%201%202%2035v34h31v31h69l15-15%2015-16v-30l-34-1h-34v-3l1-2h142v5h-40l-15%2015-15%2016v15l1%2016h70l16-16%2016-17%2014-14%2013-14v-19c0-19%200-20%202-20s2%201%202%2033v32h32l15-15%2015-15v-96l-19-1h-18v-33h-29V72h-35v-4c0-4%200-4%203-4%202%200%205-3%2017-15l15-15V3l-18-1h-17l-31%2031c-31%2030-31%2030-31%2035v4h-69V36l-17-1h-16V3l-18-1H99L83%2017m19-12l-1%2014v14h31V5l-15-1-15%201m199%200l-1%2013v13h31V5l-15-1-15%201m-31%2031l-1%2019v19H165V38l-15-1h-14v37h-35v31H70v33H35v94h27v-67h39v69h27v-18l1-18h177v36h25v-69h39v65h27v-91l-19-1h-18v-33h-29V74h-35V35h-13l-13%201m-144%2083v19h43v-38l-22-1h-21v20m137-1l1%2020h42V99h-43v19M132%20252v13h64v-26l-32-1h-32v14m105-13l-1%2013v13h66v-27h-32l-33%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/60a2182c850f400047cfb954ef3f270d/beaeb/English-One-of-several-aliens-found-in-the-se611124.webp 207w"],
                "sizes": "(max-width: 207px) 100vw, 207px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/60a2182c850f400047cfb954ef3f270d/661c4/English-One-of-several-aliens-found-in-the-se611124.png 207w"],
                "sizes": "(max-width: 207px) 100vw, 207px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/60a2182c850f400047cfb954ef3f270d/661c4/English-One-of-several-aliens-found-in-the-se611124.png",
                "alt": "English: One of several aliens found in the se...",
                "title": "English: One of several aliens found in the se...",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`English: One of several aliens found in the se...`}</figcaption>{`
  `}</figure></p>
    <p>{`I called this game space invaders - I had no knowledge of the `}<em parentName="p">{`real`}</em>{` space invaders game. Mine was just two spaceships floating above you that you would shoot at from below.`}</p>
    <p>{`I discovered `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Borland_Graphics_Interface",
        "title": "Borland Graphics Interface"
      }}>{`BGi`}</a>{` graphics so I could draw pretty things on the screen. I even knew loops this time. The problem was that I didn't know about arrays yet so there were roughly 200 global variables in the code. I remember the main problem being that Pascal said `}<em parentName="p">{`"Hey, your `}<a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Source_lines_of_code",
          "title": "Source lines of code"
        }}>{`line of code`}</a>{` can't be `}{`_`}{`that`}</em>{` long!"`}{`_`}{` so I had to break up variable definitions into separate lines.`}</p>
    <p>{`Code lost to history.`}</p>
    <h2 {...{
      "id": "3-an-os"
    }}>{`3. An "OS"`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 12 to 13`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: Pascal, text graphics and a mouse driver`}</p>
    <p><img parentName="p" {...{
        "src": "https://toastytech.com/guis/deskmateexit.gif",
        "alt": "Something like this",
        "title": "Something like this"
      }}></img></p>
    <p>{`I wanted to make a general interface to my computer that looked just as cool as `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Turbo_Pascal",
        "title": "Turbo Pascal"
      }}>{`Turbo Pascal`}</a>{` 7 did. I called it an operating system even though it was really just a visual shell running on top of DOS.`}</p>
    <p>{`It had a lot of general programs for doing various tasks - I can no longer remember how many, but I know there were a lot of menus you could click around to get to stuff. You could even run native programs (I often used it to launch Doom). You could, of course, set up different settings for how things looked and even sign in as different users.`}</p>
    <p>{`There was a secret way to type a password so you could go into Admin mode and mess around with settings of other users!`}</p>
    <p>{`Version 2 featured a much slicker `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Graphical_user_interface",
        "title": "Graphical user interface"
      }}>{`GUI`}</a>{`. (no screenshots remain, sorry)`}</p>
    <p>{`I eventually had to learn how to properly use functions and procedures because the `}<em parentName="p"><a parentName="em" {...{
          "href": "http://en.wikipedia.org/wiki/Goto",
          "title": "Goto"
        }}>{`GOTO`}</a></em>{` instruction couldn't jump around the 4000+ line monstrosity anymore. And all those "programs" you could run? Monolithic codebase, not actually different programs.`}</p>
    <p>{`Oh and I still had the problem of having to split up global variable definitions into separate lines.`}</p>
    <p>{`Code lost to history`}</p>
    <p>{`PS: I later tried to implement this in BGI graphics, but never got past the stage of drawing windows`}</p>
    <h2 {...{
      "id": "4-space-invaders-v2"
    }}>{`4. Space Invaders v2`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 12 or 13`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: Pascal and BGI`}</p>
    <p>{`At this point I still had no knowledge of the real Space Invaders game, so I made a game where you were fighting against two opponents flying to and fro above you. When you shot them down new ones would fly in.`}</p>
    <p>{`I think this was mostly due to limitations in the code (array size? number of variables for opponents? don't know).`}</p>
    <p>{`The coolest thing about this game was that you could purchase new weapons and ammunition and that the AI players could run out of ammo as well, at which point they would just crash into you.`}</p>
    <p>{`For some reason there was a potato head guy on your dashboard, offering encouragement and tips. There are no more screenshots, but I could probably reproduce the GUI with pen and paper.`}</p>
    <p>{`By this time I had gotten past my obsession with GOTO jumps, but records were still beyond my grasp. I didn't know about readability either so most of the variables were `}<em parentName="p">{`a, aa, ab`}</em>{` and so on. But I finally started indenting my code! That was lovely.`}</p>
    <p>{`Code lost to history.`}</p>
    <h2 {...{
      "id": "5-space-invaders-v3-might-have-had-a-different-name"
    }}>{`5. Space Invaders v3 (might have had a different name)`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 13`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: Pascal, 24-bit graphics, mouse driver, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/BMP_file_format",
        "title": "BMP file format"
      }}>{`BMP`}</a>{` sprite library`}</p>
    <p>{`This was my first game that started looking good. Due to limitations of memory and such you could still only play against four opponents at a time, but they finally started flying around in 2D space instaed of just left-right at the top.`}</p>
    <p>{`You could also fully play with a mouse this time so your spaceship replaced the mouse cursor and you could click to shoot. That was lovely. And so was the fact I started using BMP sprites and 24-bit graphics - it was all really shiny!`}</p>
    <p>{`Unfortunately just drawing the parallax effect on the stars in the background wasted so much resources there wasn't much that I could add to the game beyond moving around and shooting. I also had a lot of trouble with array size and the amount of bullets that could be drawn on screen.`}</p>
    <p>{`Eventually I scrapped the project because I kept getting the equivalent of a "null pointer" error and I didn't know what a pointer was.`}</p>
    <p>{`Code lost to history.`}</p>
    <h2 {...{
      "id": "6-space-invaders-3d-might-be-a-different-name"
    }}>{`6. Space Invaders 3D (might be a different name)`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 13`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: Pascal, 24-bit graphics`}</p>
    <p>{`I wanted to make a 3D engine and failed miserably. designed it around the idea that the universe is a cube and when I update whatever is on the screen, I simply have to update everything else that you don't see as well.`}</p>
    <p>{`After adding `}<strong parentName="p">{`two`}</strong>{` objects to the screen my computer would run out of memory (16MB of RAM) and it took forever to update a single step anyway, so the "game" was completely useless.`}</p>
    <p>{`Code lost to history.`}</p>
    <h2 {...{
      "id": "7-a-personal-calendar-app"
    }}>{`7. A personal calendar app`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 14`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: Delphi`}</p>
    <p>{`I think this app was some sort of way to keep track of tasks and stuff. It would show you a calendar - that I implemented manually of course. You could add events and stuff to get reminders later.`}</p>
    <p>{`Except I didn't even know how to properly calculate when it's a leap year (hint: not just "is it divisible by 4"). But it did win me the 3rd prize in a national program developing competition.`}</p>
    <p>{`Code lost to history.`}</p>
    <h2 {...{
      "id": "8-a-ww2-shooting-game"
    }}>{`8. A ww2 shooting game`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 14`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: Delphi`}</p>
    <p>{`You know you're bound to fail when you set out to make a 2D shooting game in Delphi with the idea that you can make a running animation by quickly changing sprites on an object in a window.`}</p>
    <p>{`After spending a few months getting the game menu just right, with good pictures and ominous music I lost interest and never even started working on the gameplay itself.`}</p>
    <p>{`Code lost to history.`}</p>
    <h2 {...{
      "id": "9-an-assortment-of-early-websites"
    }}>{`9. An assortment of early websites`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 15 to 16`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: PHP`}</p>
    <p>{`I can't pinpoint a specific project from this era. There were many smaller ones and a few big websites designed for the webcomics I thought I could make in those days.`}</p>
    <p>{`The main issues I had were understanding that I can't just pass state around like I'm used to in a dynamic program, HTML being a stateless protocol confused me to no end. Most of my code also relied on register globals and other monstrosities like that.`}</p>
    <p>{`Figuring out how sessions work took forever.`}</p>
    <p>{`Code lost to history.`}</p>
    <h2 {...{
      "id": "10-chlorine-boards---a-website-making-system"
    }}>{`10. Chlorine Boards - a website-making system`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 17 to 20`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: PHP`}</p>
    <p>{`After I got frustrated with the phpBB system of mods and extensions I started working on an opensource system for creating websites so that modules didn't have to know about each other at all.`}</p>
    <p>{`Essentially a good idea that even got used in the wild by some large-ish websites because I convinced a web agency that they should hire me because I can use this thing.`}</p>
    <p>{`There were at least several failings`}</p>
    <ul>
      <li parentName="ul">{`I used relational databases `}<em parentName="li">{`very`}</em>{` incorrectly (at first). To the point of not knowing how a many-to-many table works`}</li>
      <li parentName="ul">{`I wrote my own template engine and language - complete with a poorly implemented template-to-php compiler`}</li>
      <li parentName="ul">{`There was a package manager that couldn't resolve dependencies and was implemented as `}<em parentName="li">{`a 2000 sloc function`}</em></li>
      <li parentName="ul">{`Everything was a singleton`}</li>
      <li parentName="ul">{`others I can't think of`}</li>
    </ul>
    <p>{`Code still lives on sourceforge: `}<a parentName="p" {...{
        "href": "http://sourceforge.net/projects/chlorineboards/"
      }}>{`Chlorine Boards`}</a></p>
    <h2 {...{
      "id": "11-text-mining-engine-in-php"
    }}>{`11. Text mining engine in PHP`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 19 to 20`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: PHP, Perl`}</p>
    <p>{`Around the time Zemanta was launching with a very well implemented text mining system, I started working on my own. From scratch. In PHP. It grew out of a tag cloud generator and was actually pretty cool - could even make out sentences, find collocations and so on.`}</p>
    <p>{`But I should have known something was terribly wrong when I had to implement some key regular expressions in Perl because PHP's regex engine wasn't fast enough.`}</p>
    <p>{`Word of warning: don't write a sentence extractor as a regex. Even if PCRE does let you do that.`}</p>
    <p>{`I think the guy who inherited that codebase still hates me.`}</p>
    <p>{`Code lost to NDA's.`}</p>
    <h2 {...{
      "id": "12-twitulater"
    }}>{`12. Twitulater`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "600px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/c53044e4ea784e07448c1dae69c0f63a/0a47e/Swizec-Twitulater-blob-master-webby-gallery-1.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "57.847533632286996%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'231\\'%20viewBox=\\'0%200%20400%20231\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20116v115h401V0H0v116m0%200a2138%202138%200%20012-82L4%209l14-1%2011-1h-3l2-2%204-2c1-1-6-1-15-1H0v115M372%203c5%202%205%203%200%203l11%201%2015%201v10c1%2010%201%2010%201-3V2l-15-1c-15%200-15%200-12%202M27%209C6%209%204%209%204%2011c1%201%205%202%2067%202h67V9H27M5%2015v13l1%203v3h34v-3l-1-3h79V14H62L5%2015m114%202v3h20v-6h-20v3M74%2031l2%202h162l160%201v-5H236C75%2029%2074%2029%2074%2031m162%2095a1393%201393%200%20002%200%201447%201447%200%2000-2%200M107%2095a8119%208119%200%20010%20128c2%200%202-2%202-18l1-15c0%202%201%203%202%203l1-3c-1-3%200-3%202-3l4-1h1c1%201%201%201%201-1%200-3%200-3-5-3l-6%201-1%201-1-72-1-71v54m259-41c-2%2023-1%20168%201%20169l1-84c0-88-1-111-2-85m-127%2050l1%205%205%201h5V99h-11v5m-124%204l-2%201h-2c-1-1-1%200-1%204v5h11v-5c0-6-1-7-6-5m124%2021v6l1%204h10v-11h-5l-6%201m-129%2025v10h11v-10l-6-1-5%201m-65%2051v5h11v-5c0-5%200-6-2-6s-2%200-1%203l-1%202-1-2-2-1h-1c1-2%200-2-1-2-2%200-2%201-2%206m131%2012l-1%202c0%202%201%202%2027%202h26v-4l-26-1-26%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c53044e4ea784e07448c1dae69c0f63a/ca0a1/Swizec-Twitulater-blob-master-webby-gallery-1.webp 223w", "/static/c53044e4ea784e07448c1dae69c0f63a/75680/Swizec-Twitulater-blob-master-webby-gallery-1.webp 445w", "/static/c53044e4ea784e07448c1dae69c0f63a/e88ff/Swizec-Twitulater-blob-master-webby-gallery-1.webp 600w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c53044e4ea784e07448c1dae69c0f63a/e92b6/Swizec-Twitulater-blob-master-webby-gallery-1.png 223w", "/static/c53044e4ea784e07448c1dae69c0f63a/e66bf/Swizec-Twitulater-blob-master-webby-gallery-1.png 445w", "/static/c53044e4ea784e07448c1dae69c0f63a/0a47e/Swizec-Twitulater-blob-master-webby-gallery-1.png 600w"],
                "sizes": "(max-width: 600px) 100vw, 600px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c53044e4ea784e07448c1dae69c0f63a/0a47e/Swizec-Twitulater-blob-master-webby-gallery-1.png",
                "alt": "Twitulater screenshot",
                "title": "Twitulater screenshot",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Twitulater screenshot`}</figcaption>{`
  `}</figure></p>
    <p><strong parentName="p">{`Age`}</strong>{`: 20 to 21`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: Javascript, Adobe AIR`}</p>
    <p>{`The idea was simple - a twitter client that lets you filter conversations based on what's happening. Put links in different tabs, have happy tweets here and conversation tweets there. Modeled very much after TweetDeck, but better! Better in oh so many ways!`}</p>
    <p>{`Except it was utterly buggy and complete crap. There is something terribly wrong when you have 20,000 lines of spaghetti javascript on your hands, created by a guy who doesn't know enough about very simple things ... such as how Javascript handles closures and how exactly events work.`}</p>
    <p>{`Code is archived on github: `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/Twitulater"
      }}>{`Twitulater`}</a></p>
    <h2 {...{
      "id": "13-a-reinforcement-learning--based-graph-clique-analyzer"
    }}>{`13. A reinforcement learning -based graph clique analyzer`}</h2>
    <p><strong parentName="p">{`Age`}</strong>{`: 22`}</p>
    <p><strong parentName="p">{`Tech`}</strong>{`: python, django, databases`}</p>
    <p>{`Without much machine learning experience I decided that thinking of a graph as a set of objects with forces acting on them would be a good idea. Then you can just run a particle simulation and eventually the nodes that belong together will float to one another and you can pick out overlaps with a grid-segmentation algorithm.`}</p>
    <p>{`When new data flies into the system in real-time you can just tweak the forces between related nodes.`}</p>
    <p>{`Simple stuff.`}</p>
    <p>{`Except that's not `}<em parentName="p">{`really`}</em>{` how one goes about finding cliques in a graph. I didn't even know the name of the problem was "finding cliques in a graph" and thought I was breaking some awesome new ground.`}</p>
    <p>{`At first I even implemented this inside a relational database and, as you can predict, everything broke down. Calculating a single result would take seconds, even minutes ... just getting the nodes out of a database was completely untenable. The problem was slightly alleviated once we moved to App Engine and its BigTable.`}</p>
    <p>{`In retrospect, I should have used a graph database. They were just getting popular around that time too!`}</p>
    <p>{`Or, you know, use an algorithm that doesn't use an incredibly slow and complex process for the first part and then a very slow process for the second part. That might've helped.`}</p>
    <p>{`Code lost to pure shame.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://olimex.wordpress.com/2012/04/25/pascal-is-still-alive/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/86116516_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://olimex.wordpress.com/2012/04/25/pascal-is-still-alive/"
        }}>{`PASCAL is STILL ALIVE :-)`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://lifeandcode.tumblr.com/post/25517702913/iheartchaos-watch-space-invaders-come-to-life"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/95644601_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://lifeandcode.tumblr.com/post/25517702913/iheartchaos-watch-space-invaders-come-to-life"
        }}>{`iheartchaos: Watch Space Invaders come to life in this time...`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://design-milk.com/hong-kong-apartment-with-space-invaders-bathroom-by-onebynine/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/94624168_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://design-milk.com/hong-kong-apartment-with-space-invaders-bathroom-by-onebynine/"
        }}>{`Hong Kong Apartment with Space Invaders Bathroom by OneByNine`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.ohgizmo.com/2012/05/07/space-invaders-light-would-look-great-in-any-room/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/87576151_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.ohgizmo.com/2012/05/07/space-invaders-light-would-look-great-in-any-room/"
        }}>{`Space Invaders Light Would Look Great In Any Room`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=0802e75a-2abe-4e92-b9c1-abd7b930dab3",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      